function EditionStatus($el)
{
    this.$el = $el;
    this.$status = this.$el.find('[data-status]');
    this.$statusInput = this.$el.find('[data-status-input]').hide();
    this.$settings = this.$el.find('[data-settings]');
    this.$save = this.$el.find('[data-save]').hide();
    this.$modal = this.$el.find('.modal');
    this.$spinner = $('<i></i>', {
        'class' : 'fa fa-spinner fa-spin',
        'style' : 'margin-right:10px;'
    });

    this.base = 'd-ib lh-0 va-m fw-600 bdrs-10em pX-15 pY-15';
    this.info = {
        'go' : {'class': 'bgc-green-50 c-green-500', 'name': 'Go'},
        'danger' : {'class': 'bgc-orange-50 c-orange-500', 'name': 'Danger zone'},
        'nogo' : {'class': 'bgc-red-50 c-red-500', 'name': 'No-Go'},
        'unknown' : {'class': 'bgc-blue-50 c-blue-500', 'name': 'Unknown'}
    };

    this.events();
}

EditionStatus.prototype.events = function()
{
    var self = this;

    this.$settings.on('click', function(){
        self.$settings.hide();
        self.$status.hide();
        self.$statusInput.show();
        self.$save.show();
    });

    this.$save.on('click', function(){
        if(self.$statusInput.val() !== self.$statusInput.data('default-value')) {
            self.$modal.find('.modal-body').html('<p>Are you sure you want to change the status of this edition to <strong>'+self.$statusInput.find('option:selected').text()+'</strong>?</p>');
            self.$modal.modal('show');
        } else {
            self.hideEdit();
        }
    });

    this.$modal.find('.btn-primary').on('click', function(){
        $(this).prepend(self.$spinner);
        self.save();
    });

    this.$modal.find('.btn-secondary').on('click', function(){
        self.hideEdit();
        self.$modal.modal('hide');
        self.$statusInput.val(self.$statusInput.data('default-value'));
    });
}

EditionStatus.prototype.hideEdit = function()
{
    this.$settings.show();
    this.$status.show();
    this.$statusInput.hide();
    this.$save.hide();
}

EditionStatus.prototype.save = function()
{
    var self = this,
        value = this.$statusInput.val();

    $.ajax({
        method: 'POST',
        url: '/courses/editions/' + this.$el.data('id') + '/status',
        data: { status: value }
    }).done(function( msg ) {
        self.hideEdit();
        self.$modal.modal('hide');
        self.$modal.find('.btn-primary i').remove();

        if(msg.success) {
            self.$statusInput.data('default-value', value);
            self.$status
                .find('span')
                .attr('class', self.base + ' ' + self.info[value].class)
                .text(self.info[value].name);

            //for tables
            if (self.$el.next('.gladwell-status').length == 1) {
                self.$el.next('.gladwell-status').attr('class', 'gladwell-status ' + value);
            }
        } else {
            alert('Er is helaas iets fout gegaan, probeer later opnieuw of neem contact op met Fluffy Media.');
        }
    });
}


function EditionTableStatus($els)
{
    this.$els = $els;
    this.$containers = this.$els.find('[data-table-status-container]');

    this.init();
    this.events();
}

EditionTableStatus.prototype.init = function()
{
    var self = this;

    this.$els.each(function(){
        new EditionStatus($(this).find('[data-table-status-container]'));
    });
}

EditionTableStatus.prototype.events = function()
{
    var self = this;

    this.$els.on('click', '.gladwell-status', function() {
        self.hideContainers();
        $(this).prev('[data-table-status-container]').show();
    });

    $('body').on('click', function(e){
        var $el = $(e.target);
        if($el.hasClass('fa-times') || (!$el.hasClass('gladwell-status') && $el.closest('[data-table-status-container]').length === 0)) {
            self.hideContainers();
        }
    });
}

EditionTableStatus.prototype.hideContainers = function()
{
    var $containers = this.$containers.filter(':visible');

    $containers.hide();
    $containers.find('[data-status]').show();
    $containers.find('[data-status-input]').hide();
    $containers.find('[data-settings]').show();
    $containers.find('[data-save]').hide();

    $containers.each(function(){
        var $input = $(this).find('[data-status-input]');
        $input.val($input.data('default-value'));
    });
}

$(document).ready(function(){
    var $container = $('[data-status-container]');
    if($container.length == 1)
        new EditionStatus($container);

    var $containers = $('.gladwell-status-column');
    if($containers.length >= 1)
        new EditionTableStatus($containers);
});